<template lang="html">

    <section class="cover-popup-errores"
    v-if="!!error || !!errorMensaje"
    :cat="(!!error) ? error.categoria : 'medium'">

        <div class="popup-errores" v-if="!!error">
            <h2>{{error.es.titulo}}</h2>
            <p v-html="error.es.cuerpo"></p>
            <a class="close" @click="eraseError" v-if="!!!error.es.to">✕</a>
            <a @click="eraseError" v-if="error.categoria != 'secondary' && !!!error.es.to" class="cerrar btn">Aceptar</a>
            <a @click="linkbefore(error.es.to)" v-if="!!error.es.to" class="btn">Aceptar</a>
        </div>

        <div class="popup-errores" v-if="!!errorMensaje">
            <h2>Error</h2>
            <p>{{errorMensaje}}</p>
            <a @click="eraseError" class="close">✕</a>
        </div>

    </section>

</template>

<script lang="js">

    import data from '@/errors';

    import {mapGetters, mapActions} from 'vuex';


    import router from '@/router';

    export default {
        name: 'popup-errores',
        data() {
            return {
                errorslist: ''
            }
        },
        created() {
            this.errorslist = data;
        },
        computed: {
            ...mapGetters({
                errorNumber : 'getError',
                errorMensaje : 'getErrorMensaje'
            }),
            error:function(){
                if (!!this.errorslist && !!this.errorNumber) {
                    return this.errorslist[this.errorNumber];
                }
            }
        },
        methods : {
            ...mapActions(['eraseError']),
            linkbefore(to){
                this.eraseError();
                router.push({name : to});
            }
        }
    }
</script>

<style scoped lang="scss">



</style>


// WEBPACK FOOTER //
// src/components/parts/popup-errores.vue